require('./loanHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classnames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @helpers
const { getFinalTitle } = require('core/i18n').i18n;
// @ components
const LoansCreditsMoreOptionsButton = require('../../loansCreditsMoreOptionsButton/loansCreditsMoreOptionsButton');
const LoanHeaderDetails = require('../loanHeaderDetails/loanHeaderDetails');
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
// @utilities
const {
    commonAnalyticsId,
    commonCatalogue,
} = require('utilities/taggingCommonCatalogue');
const { recordLinkV2 } = require('utilities/tagging');
class LoanHeader extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildMoreOptions() {
        const { immLoan, isARES } = this.props;
        return immLoan && !immLoan.get('isOldLoan') ? (
            <LoansCreditsMoreOptionsButton
                isARES={isARES}
                id={immLoan.get('loanId')}
                type={immLoan.get('type')}
                isRestrictedLoan={immLoan.get('isRestrictedLoan')}
                productSubType={immLoan.get('productSubType')}
                productType={immLoan.get('product')}
            />
        ) : null;
    }

    buildDetails() {
        const {
            immLoan,
            showDetails,
            showAnotherDetails
        } = this.props;
        let headerDetails;

        if (immLoan && showDetails) {
            const loanHeaderDetailsClasses = classnames(
                'loan-header__details',
                {
                    'loan-header__details--no-button': immLoan.get('isOldLoan')
                }
            );

            headerDetails = (
                <div className={loanHeaderDetailsClasses}>
                    <LoanHeaderDetails immLoan={immLoan} />
                </div>
            );
        } else if (showAnotherDetails) {
            headerDetails = showAnotherDetails;
        }

        return headerDetails;
    }

    onClickEdit() {
        recordLinkV2(commonCatalogue[commonAnalyticsId.COMMON_BUTTON]('editar alias de prestamo'));
    }

    render() {
        const {
            immLoan,
            breadcrumbConfig,
            handlePostAlias,
            titleIsEditable,
            titleEditable,
            title,
            tutorial
        } = this.props;

        const moreOptionsButton = this.buildMoreOptions();
        const headerDetails = this.buildDetails();
        let titleKey;

        if (!titleIsEditable || __CONTACT_CENTER__) {
            titleKey = title ? title : immLoan.get('alias');
        }

        return (
            <article className="loan-header">
                <OKCover size="medium" section="loansmortgages">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumbConfig}
                        titleIsEditable={titleIsEditable && !__CONTACT_CENTER__}
                        titleEditable={titleEditable}
                        titleEditableAction={handlePostAlias}
                        finalTitle={getFinalTitle(titleKey)}
                        tutorial={tutorial}
                        handleOnClickEdit={this.onClickEdit}
                    >
                        {headerDetails}
                        {moreOptionsButton}
                    </OKHeaderSubPage>
                </OKCover>
            </article>
        );
    }
}

LoanHeader.propTypes = {
    immLoan: PropTypes.object.isRequired,
    breadcrumbConfig: PropTypes.array,
    title: PropTypes.string,
    titleIsEditable: PropTypes.bool.isRequired,
    titleEditable: PropTypes.string,
    handlePostAlias: PropTypes.func,
    showDetails: PropTypes.bool,
    showAnotherDetails: PropTypes.any,
    tutorial: PropTypes.object,
    isARES: PropTypes.boolean
};

LoanHeader.defaultProps = {
    titleIsEditable: false,
    showDetails: true,
    showAnotherDetails: false,
    tutorial: null,
    isARES: false
};

module.exports = LoanHeader;
